import { Edit, useForm } from "@refinedev/antd";
import { Form, Input, Button, Space, Alert } from "antd";
import { useNavigate } from "react-router-dom";

// Edycja tytułu jednego przetargu (po `pretty_id`). `useForm` pobiera rekord z
// GET /admin/auctions/:id (pole `subject` = aktualny wyświetlany tytuł) i zapisuje
// przez PUT /admin/auctions/:id, które proxuje do mercury_hub i synchronizuje wyszukiwarki.
export const AuctionEdit = () => {
  const navigate = useNavigate();
  const { formProps, saveButtonProps } = useForm();

  return (
    <Edit
      title="Edytuj tytuł przetargu"
      saveButtonProps={saveButtonProps}
      footerButtons={({ defaultButtons }) => (
        <Space>
          <Button onClick={() => navigate("/auctions")}>Anuluj</Button>
          {defaultButtons}
        </Space>
      )}
    >
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="Zmiana tytułu utworzy nową rewizję i zsynchronizuje obie wyszukiwarki (OpenSearch + Meilisearch)."
      />
      <Form {...formProps} layout="vertical">
        <Form.Item label="pretty_id" name="pretty_id">
          <Input disabled />
        </Form.Item>

        <Form.Item
          label="Tytuł (wyświetlany, PL)"
          name="subject"
          rules={[{ required: true, message: "Tytuł jest wymagany" }]}
        >
          <Input.TextArea rows={2} placeholder="Tytuł przetargu" />
        </Form.Item>
      </Form>
    </Edit>
  );
};
